module.exports = "/images/fi.svg?541165d54ea86e16431baf218da10d71";